import axios, { AxiosResponse } from 'axios';
import { appendTokenToUrl } from '../components/context/Recaptcha';

const {
  additionalHeaders,
  webCredentialsUrl,
  forgeRockAuthenticationUrl,
  create_federation_path, // eslint-disable-line @typescript-eslint/naming-convention
  PI_SESSION,
  loginRootUrl,
} = window.appAirDrop.config;

export interface MFAData {
  countryCode?: string;
  maskedEmailAddress?: string;
  lang?: string;
  mfaSignInEscrow?: string;
  maskedPhoneNumber?: string;
  flow?: string;
}

export interface SAMLData {
  samlRedirectRequired: boolean;
  federationSessionType: string;
}

export interface WebcredentialsData extends MFAData, SAMLData {
  access_token: string;
  refresh_token: string;
  expires_in: string;
  userId: string;
  homeCountryCode?: string;
  sessionId: string;
  loginSuccessUrl: string;
  forceResetPasswordUrl: string;
  sessionExpiryTime: string;
  smsUserId: string;
  deviceId: string;
  firstName: string;
  remindToAddMobileNumber: boolean;
  smsRedirectUrl: string;
  dob: string;
  isSkipDobPrompt: boolean;
}

export interface WebcredentialsResponseData {
  status: string;
  data: WebcredentialsData;
}

export async function postWebcredentials(
  signinData: any,
  recaptchaToken?: string,
): Promise<AxiosResponse<WebcredentialsResponseData>> {
  const response = await axios.post(
    appendTokenToUrl(webCredentialsUrl, recaptchaToken),
    new URLSearchParams(signinData).toString(),
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      withCredentials: true,
    },
  );

  return response;
}

export async function forgerockSignIn(signinData: any) {
  const { username, password } = signinData;
  const headers = {
    'X-OpenAM-Username': username,
    'X-OpenAM-Password': password,
  };

  const response = await axios.post(forgeRockAuthenticationUrl, {
    headers,
    withCredentials: true,
  });

  return response;
}

export async function LinkAccountsSignIn(linkAccountsData: any) {
  const response = await axios.post(
    `${create_federation_path}/${PI_SESSION?.linkAccounts_escrow}`,
    new URLSearchParams(linkAccountsData).toString(),
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      withCredentials: true,
    },
  );
  return response;
}

// V1 -> v2 sign in with code
export function getSamlRedirectUrl(targetUrl: string, sessionType: string) {
  const samlRedirectUrl = new URL(`${loginRootUrl}/login/saml/generateResponse`);
  const params: URLSearchParams = samlRedirectUrl.searchParams;
  const targUrl = new URL(targetUrl);
  params.set('targetUrl', targUrl.toString()); // does the URL encoding
  params.set('sessionType', sessionType);
  return samlRedirectUrl.toString();
}
